import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowComplaints from '../components/Complaints/ShowComplaints'

const Complaints:React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("Les Plaintes")}</h1>
      <ShowComplaints />
    </div>
  )
}

export default Complaints